<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" >
      <TabPane name="1" label="项目列表" v-if="p('projectSearch/projectList')">
        <c1></c1>
      </TabPane>
      <TabPane name="2" label="房型列表" v-if="p('houseTypeSearch/list')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="增量刷新" v-if="p('houseSearch/flushHouseData')">
        <c3></c3>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/searchManage/project/index'
  import C2 from '@/views/searchManage/houseType/index'
  import C3 from '@/views/searchManage/increateflush/index'
  import {mixin} from "../../mixin";

  export default {
    name:'search',
    mixins:[mixin],
    components:{
      C1,
      C2,
      C3,
    }        ,
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
